import { render, staticRenderFns } from "./GroupMoveSelector.vue?vue&type=template&id=6c18a63e&scoped=true&"
import script from "./GroupMoveSelector.vue?vue&type=script&lang=js&"
export * from "./GroupMoveSelector.vue?vue&type=script&lang=js&"
import style0 from "./GroupMoveSelector.vue?vue&type=style&index=0&id=6c18a63e&prod&scoped=true&lang=css&"
import style1 from "./GroupMoveSelector.vue?vue&type=style&index=1&id=6c18a63e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c18a63e",
  null
  
)

export default component.exports